import React, { useState, useEffect } from "react";
import Header from "../../../Components/adminDashboard/Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import combinedServices from "../../../shared/services/user-service";

const UsersforPOS = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [statuschange, setStatuschange] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [stores, setStores] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [currentStore, setCurrentStore] = useState(null);
  
  // Get storeId from URL parameters
  const urlParams = new URLSearchParams(location.search);
  const storeId = urlParams.get('storeId');

  const totalPages = Math.ceil(totalUsers / limit);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        let usersData = await combinedServices.getAllFilteredUserNames(
          page,
          limit,
          searchQuery,
        );
        if (usersData && usersData.data) {
          setUserData(usersData.data.data.data || []);
          setTotalUsers(usersData.data.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching Users:", error);
      }
    };

    const fetchCurrentStore = async () => {
      if (storeId) {
        try {
          const storesData = await combinedServices.getstore(1, 1, '');
          if (storesData && storesData.data) {
            const store = storesData.data.data.stores.find(s => s.id === parseInt(storeId));
            setCurrentStore(store);
          }
        } catch (error) {
          console.error("Error fetching store:", error);
        }
      }
    };

    fetchUsers();
    fetchCurrentStore();
  }, [page, limit, searchQuery, statuschange, storeId]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const formatPhoneNumber = (areaCode, mobile) => {
    return areaCode && mobile ? `(${areaCode}) ${mobile}` : "N/A";
  };

  const openStoreModal = async (user) => {
    setSelectedUser(user);
    try {
      const storesData = await combinedServices.getstore(page, limit, '');
      if (storesData && storesData.data) {
        setStores(storesData.data.data.stores || []);
      }
      
      // Pre-select stores based on user's StorePOS data
      if (user.StorePOS && user.StorePOS !== '0') {
        const userStoreIds = user.StorePOS.split(',').map(id => parseInt(id.trim()));
        setSelectedStores(userStoreIds);
      } else {
        setSelectedStores([]);
      }
      
      // If we're in store-specific mode, pre-select only that store
      if (storeId) {
        setSelectedStores([parseInt(storeId)]);
      }
      
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedUser(null);
    setStores([]);
    setSelectedStores([]);
  };

  const handleStoreSelection = (storeId) => {
    setSelectedStores(prev => 
      prev.includes(storeId) 
        ? prev.filter(id => id !== storeId)
        : [...prev, storeId]
    );
  };

  const handleSubmit = async () => {
    try {
      const storeIds = selectedStores.length > 0 ? selectedStores.join(',') : '0';
      const response = await combinedServices.changeuserPOSstatus({ 
        userID: selectedUser.id,
        storeIds: storeIds
      });
      
      if (response.data.success) {
        setStatuschange(prev => !prev);
        closeModal();
      }
    } catch (error) {
      console.error("Error updating POS status:", error);
    }
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight newDbRight">
        <div className="dbMid dbInner">
          <div className="dbMainHd">
            {currentStore ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button 
                  onClick={() => navigate('/poslist')}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '18px',
                    cursor: 'pointer',
                    color: '#007bff'
                  }}
                  title="Back to Store List"
                >
                  ← 
                </button>
                <span>POS Management - {currentStore.storename}</span>
              </div>
            ) : (
              'POS Management for users'
            )}
          </div>
          <div className="catFilterWrp">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="catFilterCont">
                <div className="filWrp">
                  <label className="label2">Showing</label>
                  <select
                    value={limit}
                    onChange={handleLimitChange}
                    className="form_ctrl ctrlDrop"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="ent">entries</span>
                  <div className="srchGrp">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="form_ctrl ctrlSrch"
                      placeholder="Search by name, email or phone"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="listTablWrp">
            <div className="tblWrp">
              <table>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {userData.length > 0 ? (
                    userData.map((user, index) => (
                      <tr key={user.id}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td>{user.user_firstname + ' ' + user.user_lastname || "N/A"}</td>
                        <td>{user.user_email || "N/A"}</td>
                        <td>
                          {formatPhoneNumber(
                            user.user_areacodemobile,
                            user.user_mobile
                          )}
                        </td>
                        <td>
                          {/* <div className="tblBtnWrp"> */}
                            <button 
                              className="btn btn-outline-primary"
                              onClick={() => openStoreModal(user)}
                              style={{
                                padding: '6px 12px',
                                fontSize: '12px',
                                borderRadius: '4px',
                                border: '1px solid #007bff',
                                backgroundColor: 'transparent',
                                color: '#007bff',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px'
                              }}
                            >
                              <span>🏪</span>
                              Manage Stores
                            </button>
                          {/* </div> */}
                        </td>
                        <td>
                          {/* Add action buttons here if needed */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center" }}>
                        No Users Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="tblPagiWrp">
              <ul className="pagination namPagi">
                <li>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    Prev
                  </button>
                </li>

                {/* Always show first page */}
                <li>
                  <button
                    className={page === 1 ? "active" : ""}
                    onClick={() => handlePageChange(1)}
                  >
                    1
                  </button>
                </li>

                {/* Show ellipsis if current page is more than 4 */}
                {page > 4 && <li className="disabled"><span>...</span></li>}

                {/* Show pages around current page */}
                {Array.from({ length: totalPages }, (_, index) => {
                  const pageNumber = index + 1;
                  // Show only pages that are within 3 of current page, but not first or last page
                  if (
                    pageNumber > 1 &&
                    pageNumber < totalPages &&
                    Math.abs(pageNumber - page) <= 3
                  ) {
                    return (
                      <li key={index}>
                        <button
                          className={page === pageNumber ? "active" : ""}
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    );
                  }
                  return null;
                })}

                {/* Show ellipsis if current page is more than 3 away from last page */}
                {page < totalPages - 3 && <li className="disabled"><span>...</span></li>}

                {/* Always show last page if there's more than 1 page */}
                {totalPages > 1 && (
                  <li>
                    <button
                      className={page === totalPages ? "active" : ""}
                      onClick={() => handlePageChange(totalPages)}
                    >
                      {totalPages}
                    </button>
                  </li>
                )}

                <li>
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Store Selection Modal */}
      {showModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '500px',
            maxHeight: '600px',
            overflow: 'auto'
          }}>
            <div className="modal-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h3>Select Store for {selectedUser?.user_firstname} {selectedUser?.user_lastname}</h3>
              <button onClick={closeModal} style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer'
              }}>×</button>
            </div>
            <div className="store-list">
              {stores.length > 0 ? (
                stores.map((store) => (
                  <div key={store.id} style={{
                    padding: '10px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <input 
                      type="checkbox"
                      checked={selectedStores.includes(store.id)}
                      onChange={() => handleStoreSelection(store.id)}
                      style={{ marginRight: '10px' }}
                    />
                    {(() => {
                      try {
                        const images = JSON.parse(store.storeimage);
                        return images[0] && (
                          <img 
                            src={images[0]} 
                            alt={store.storename}
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                              marginRight: '10px'
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        );
                      } catch {
                        return null;
                      }
                    })()}
                    <div>
                      <h4 style={{ margin: '0 0 5px 0' }}>{store.storename}</h4>
                      <p style={{ margin: '0', fontSize: '12px' }}>Available: {store.isAvailable ? 'Yes' : 'No'}</p>
                      <p style={{ margin: '0', fontSize: '12px' }}>Open: {new Date(store.openDate).toLocaleDateString()} - {new Date(store.closeDate).toLocaleDateString()}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p>No stores available</p>
              )}
            </div>
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
              <button 
                onClick={closeModal}
                style={{
                  marginRight: '10px',
                  padding: '8px 16px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button 
                onClick={handleSubmit}
                style={{
                  padding: '8px 16px',
                  backgroundColor:'#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor:'pointer'
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UsersforPOS;